import { render, staticRenderFns } from "./LeadOpNotesIcon.vue?vue&type=template&id=4ca69907&scoped=true"
import script from "./LeadOpNotesIcon.vue?vue&type=script&lang=ts"
export * from "./LeadOpNotesIcon.vue?vue&type=script&lang=ts"
import style0 from "./LeadOpNotesIcon.vue?vue&type=style&index=0&id=4ca69907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca69907",
  null
  
)

export default component.exports